import React, { useEffect, useState, useRef} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";

import ReactTableBuilder from "../../utils/reactTableBuilder";
import poApi from "../../api/poApi";
import masterpackApi from "../../api/masterpackApi";
import palletApi from "../../api/palletApi";
import cameraModelApi from "../../api/cameraModelApi";


import { getCurrentAuthUser } from "../../utils/authorization";
import { useAppContext } from "../../components/context/appContext"
import { expeditionType } from "../../actions/staticDataList";
import { useReactToPrint } from "react-to-print";
import { Box, Divider, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import BigButton from "../../components/material/bigButton"
import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow } from "../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../components/inputs';
import PalletLabel from '../../components/label/palletLabel';


function NewPallet(props) {
  const { t } = props;
  const [userAuth, setUserAuth] = useState();
  const [poList, setPoList] = useState();
  const [selectedExpeditionType, setSelectedExpeditionType] = useState();
  const [scannerValue, setScannerValue] = useState();
  const [scannerError, setScannerError] = useState();
  const [palletConfiguration, setPalletConfiguration] = useState({totalUnits:0,totalMasterpacks:0});
  const [mixedPallet, setMixedPallet] = useState(false);
  const [currentPallet, setCurrentPallet] = useState({totalUnits:0, totalMasterpacks:0, palletBarcode:""});
  const [tableData, setTableData] = useState([]);
  const [specialRemark, setSpecialRemark] = useState("");
  const [palletLabelInfo, setPalletLabelInfo] = useState();
  const appContext = useAppContext();

  let printContentRef = useRef(null);

  useEffect(()=>{
    doInitialLoad();
  },[])

  async function doInitialLoad() {
    const res= await getCurrentAuthUser();
    setUserAuth(res);
    loadPoList(res.plant.netsuiteCmId);
  }

  function loadPoList(currentCmId) {
    return poApi.getOpenPoOnCm(currentCmId).then((result) => {
      if (result.data.status === "success") {
        let pos = result.data.data.pos;
        pos.sort((a, b) =>
          a.tranName > b.tranName ? 1 : b.tranName > a.tranName ? -1 : 0
        );
        setPoList(pos);
      }
    });
  }

  function getPoNameFromId(poId) {
    const currentPo = poList?.find((po)=> po.poId === poId);
    if(currentPo)
      return currentPo?.tranName;
    return poId;
  }

  useEffect(()=>{
    if(mixedPallet)
      appContext.showMessage(t('warning'),t('newPallet.mixedPalletChecked'))
  },[mixedPallet])

  useEffect(() => {
    if(!scannerValue && scannerValue !== "")
    {
      setScannerError("");
      return;
    }
  },[scannerValue])

  useEffect(() =>{
    if(palletLabelInfo){
      handlePrint();
      setPalletLabelInfo(undefined);
      setCurrentPallet({totalUnits:0, totalMasterpacks:0, palletBarcode:""});
      setSpecialRemark("");
      setTableData([]);
    }
  }, palletLabelInfo)

  const handlePrint = useReactToPrint({
    content: () => printContentRef,
  });

  function startPallet() {
    palletApi.newPallet().then((res)=>{
      if(res.status === 200){
        setCurrentPallet({
          palletBarcode: res.data.barcode,
          totalUnits: currentPallet.totalUnits,
          totalMasterpacks: currentPallet.totalMasterpacks
        })
      }
      else{
        appContext.showMessage(t('error'),"An unexpected error happened.")
      }

    })
    .catch((err)=> {
      console.log(err);
      appContext.showMessage(t('error'),"An unexpected error happened.")
    })
  }

  function closePalletAndPrint() {
    const models = [...new Set(tableData.map(item => item.masterpack.cameraModel.name ))].map((modelName => {
      const masterpackArray = tableData.filter(row => row.masterpack.cameraModel.name === modelName);
      return {
        masterpacks: masterpackArray.length,
        units: masterpackArray.reduce((acc, row) => acc + row.masterpack.items.length, 0),
        name:modelName
      }
    }));
    setPalletLabelInfo({
      barcode:currentPallet.palletBarcode,
      totalUnits: currentPallet.totalUnits,
      totalMasterpacks: currentPallet.totalMasterpacks,
      models:models
    })

    palletApi.updatePallet(currentPallet.palletBarcode,{
      note:specialRemark,
      status:"packed",
      expeditionType: selectedExpeditionType?.value.toLowerCase()
    }).then(()=>{
     
    });      
  }

  function scannerOnKeyDown(e){
    if (e.key === 'Enter') {
      handleScan(e.target.value);
    }
  }

  
  async function handleScan(scan) {
    try{
      if(!scan)
      {
        setScannerError("");
        return;
      }
        
      const result =  (await masterpackApi.getMasterpackSN(scan)
        .then((res)=>{ return res;})
        .catch((error)=> {console.log(error); return error;})
      );

      if(!result?.data)
      {
        setScannerError(t('newPallet.masterpackNotFound'));
        return;
      }
      const masterpack = result?.data;
      console.log(masterpack);

      if(masterpack.palletBarcode){
        //Show yes/no pop-up
        appContext.showConfirmationMessage(t("warning"),t("newPallet.masterpackOnOtherPallet"), 
          async () => { 
            palletApi.removeMasterpackFromPallet(masterpack.palletBarcode, masterpack.barcode).then(()=>{
              processMasterpackOnPallet(masterpack);
            })
          },
          () => { console.log('Operation canceled!') })
        return;
        //Yes -> Remove from old pallet and then put in new
      }

      await processMasterpackOnPallet(masterpack);
    }
    catch(err){
      console.log('Error', err);
      appContext.showMessage(t('error'),"An unexpected error happened");
    }
    finally{
      resetScan();
    }
    
  }

  //TODO this function I made is super bad, it does way too many things and its hard to understand
  //If someone sees this and has time to split it into different functions... please.
  async function processMasterpackOnPallet(masterpack){
    try {
      let hasWarning = false;
      let warningMessage = "";

      const newTableRow={};
      newTableRow.masterpack = masterpack;
      newTableRow.masterpackNo = masterpack.barcode;
      newTableRow.cameraModel = masterpack.cameraModel.name;
      if(masterpack.items.length > 0)
        newTableRow.poId = masterpack.items[0].poNumber;
      else {
        appContext.showMessage(t('error'), t('newPallet.emptyMasterPackError'));
        return;
      }

      if(tableData.length > 0)
      {
        if(tableData.find((row)=> row.masterpackNo === masterpack.barcode)){
          appContext.showMessage(t('warning'), t('newPallet.masterpackAlreadyOnPallet'));
          return;
        }

        if(tableData[0].cameraModel !== masterpack.cameraModel.name)
        {
          hasWarning = true;
          warningMessage += t("newPallet.mixedPalletWarningModel", { cameraModel: masterpack.cameraModel.name });
          setSpecialRemark(specialRemark + t("newPallet.mixedPalletWarningModel", { lng: "en", cameraModel: masterpack.cameraModel.name }) + '\n');
        }

        if(masterpack.items.length > 0 && tableData[0].poId !== masterpack.items[0].poNumber)
        {
          hasWarning = true;
          warningMessage += ' ' + t("newPallet.mixedPalletWarningPo", { poId: masterpack.items[0].poNumber });
          setSpecialRemark(specialRemark + t("newPallet.mixedPalletWarningPo", { lng: "en", poId: masterpack.items[0].poNumber }) + '\n')
        }
      }
      else {
        const cameraModel = await cameraModelApi.getCameraModel(masterpack.cameraModel.name);

        //START FIND PALLET CONFIGURATION
        let newPalletConfiguration = cameraModel.data?.palletConfigurations?.find((config) =>{
          console.log(config)
          if(config.affectedCm === userAuth.plant.netsuiteCmId && config.expeditionType.toLowerCase() === selectedExpeditionType.value.toLowerCase())
            return true;
          return false;
        })
        if(!newPalletConfiguration)
        {
          newPalletConfiguration = cameraModel.data?.palletConfigurations?.find((config) =>{
            if(config.affectedCm.toString() === "0" && config.expeditionType.toLowerCase() === selectedExpeditionType.value.toLowerCase())
              return true;
            return false;
          })
        }

        if(!newPalletConfiguration)
          appContext.showMessage('warning', t('newPallet.noPalletConfigurationFound',{ cameraModel:cameraModel.data.name, expeditionType:selectedExpeditionType.label}));
        else {
          console.log(newPalletConfiguration);
          setPalletConfiguration({
            totalUnits: newPalletConfiguration.totalUnits,
            totalMasterpacks: parseInt(newPalletConfiguration.totalUnits) / parseInt(newPalletConfiguration.unitsPerMasterpack)
          })
        }
        //END FIND PALLET CONFIGURATION
      }

      if(!mixedPallet && hasWarning)
        appContext.showMessage(t('warning'), warningMessage);

      
      //TODO Validate pallet limitation wtih a popup if necessary
      const updatedPallet = {
        ...currentPallet,
        totalUnits: currentPallet.totalUnits + masterpack.items.length,
        totalMasterpacks: currentPallet.totalMasterpacks + 1,
      };

      if(palletConfiguration.totalMasterpacks > 0)
      {
        if(updatedPallet.totalMasterpacks >= palletConfiguration.totalMasterpacks){
          let warningMessage = t('newPallet.palletLimitReached');
          console.log(`${updatedPallet.totalUnits} < ${palletConfiguration.totalUnits}`)
          if(updatedPallet.totalUnits < palletConfiguration.totalUnits)
            warningMessage += ' '+t('newPallet.palletLimitReachedNotEnoughCamera');

          appContext.showMessage(t('warning'), warningMessage);
        }
      }

      var addToPalletResult = await palletApi.addMasterpackToPallet(currentPallet.palletBarcode, masterpack.barcode);
      if(addToPalletResult.status === 200){
        
        setCurrentPallet(updatedPallet);

        setTableData((prevItems) => [...prevItems, newTableRow]);
        setScannerError("");
      }
      else{
        appContext.showMessage(t('error'),"An unexpected error happened");
      }
    }
    catch(err){
      console.log('Error', err);
      appContext.showMessage(t('error'),"An unexpected error happened");
    }
    finally{
      resetScan();
    }
  }



  async function resetScan() {
    setScannerValue("");
    //TODO Set focus if not focused??
  }

  function getPalletConfigurationTotalMasterPacks() {
    if(!palletConfiguration)
      return undefined;

    return parseInt(palletConfiguration.totalUnits) / parseInt(palletConfiguration.unitsPerMasterpack);
  }

  function removeMasterpack(masterpackNo, indexToRemove) {
    palletApi.removeMasterpackFromPallet(currentPallet.palletBarcode, masterpackNo).then(()=>{
      const masterpackRow = tableData.find((row) => row.masterpackNo === masterpackNo);
      if(masterpackRow) {
        setCurrentPallet({
          totalUnits: currentPallet.totalUnits - masterpackRow.masterpack.items.length,
          totalMasterpacks: currentPallet.totalMasterpacks - 1,
          palletBarcode: currentPallet.palletBarcode
        });
      }
      setTableData((prevItems) => prevItems.filter((_, index) => index !== indexToRemove));
    })
  }

  const columns = [
    {
      Header: t('dashboard_main.masterpack'),
      accessor: "masterpackNo",
    },
    {
      Header: t('dashboard_main.camera_model'),
      accessor: "cameraModel",
    },
    {
      Header: t('po_detail.po_number'),
      accessor: (row)=>{
        return getPoNameFromId(row.poId);
      },
    },
    {
      Header: t('action'),
      accessor: (row, index)=>{
        return (
          <IconButton variant="contained" color="error" aria-label="delete" onClick={()=>{removeMasterpack(row.masterpackNo, index)}}>
            <DeleteIcon />
          </IconButton>
        );
      },
    }
  ];

  return (
    <>
      <StandardPage
        title={t("newPallet.title")}
        description={t("newPallet.title_desc")}
        showPrinterStatus={true}
      >
        <StandardPageTopContent>
          <MuiRow>
            <MuiCol size={{ xs:12, md:6}}>
              <MuiRow spacing={1}>
                <MuiCol size={{ xs:12, md:6}}>
                  <BigButton onClick={startPallet} disabled={!(currentPallet.palletBarcode === '')}>
                    {t("newPallet.startNewPallet")}
                  </BigButton>
                </MuiCol>
                <MuiCol size={{ xs:12, md:6}}>
                <BigButton onClick={closePalletAndPrint} 
                       disabled={currentPallet.palletBarcode === ''}
                      >
                      {t("newPallet.finishPalletAndPrintLabel")}
                      </BigButton>
                </MuiCol>
              </MuiRow>
              <MuiRow>
                <MuiCol size={{ xs:12, md:6}}>
                  <MuiSelect disabled={tableData.length > 0}
                    options={expeditionType?.map(expTy => ({label:expTy.name, value:expTy.id})) ?? []}
                    placeholder={t("pallet_configuration.expedition_type")}
                    value={selectedExpeditionType}
                    onChange={setSelectedExpeditionType}
                  />
                </MuiCol>
                <MuiCol size={{ xs:12, md:6}}>
                  <MuiCheckbox label={t("newPallet.mixedPallet")}
                    value={mixedPallet}
                    onChange={setMixedPallet} />
                </MuiCol>
              </MuiRow>
            </MuiCol>
            <MuiCol size={{ xs:12, md:6}}>
              <MuiTextArea
                label={t("newPallet.specialRemark")}
                value={specialRemark}
                onChange={setSpecialRemark}
              />
            </MuiCol>
          </MuiRow>
          <Box
            sx={{
              backgroundColor: 'grey.100',
              border: '1px solid grey',
              borderRadius: '8px',
              padding: 2,
              marginTop:1,
              marginBottom:2,
              width: '100%',
            }}>
            <MuiRow spacing={2}>
            <MuiCol size={{xs:12, md:5}}>
                <MuiRow spacing={1}>
                  { currentPallet.palletBarcode === '' ?  
                  <MuiCol size={12}>{t("newPallet.noPallet")}</MuiCol> 
                  :
                  <>
                    <MuiCol size={12}>{t("newPallet.currentPallet",{ palletNumber: currentPallet.palletBarcode})}</MuiCol>
                    <MuiCol size={{ xs:12, md:6}}>
                      <MuiTextField
                        disabled
                        value={currentPallet?.totalUnits}
                        label={t("pallet_configuration.total_units")}
                      />
                    </MuiCol>
                    <MuiCol size={{ xs:12, md:6}}>
                      <MuiTextField disabled
                        value={currentPallet?.totalMasterpacks}
                        label={t("pallet_configuration.total_masterpacks")}/>
                    </MuiCol>
                  </>
                  }
                </MuiRow>
              </MuiCol>
              <MuiCol size={{xs:0, md:1}}/>
              <Divider orientation="vertical" flexItem />
              <MuiCol size={{xs:12, md:5}}>
                <MuiRow spacing={1}>
                  <MuiCol size={12}>{t("newPallet.palletConfiguration")}</MuiCol>
                  <MuiCol size={{ xs:12, md:6}}>
                    <MuiTextField
                      disabled
                      value={palletConfiguration?.totalUnits}
                      label={t("pallet_configuration.total_units")}
                    />
                  </MuiCol>
                  <MuiCol size={{ xs:12, md:6}}>
                    <MuiTextField
                      disabled
                      value={palletConfiguration?.totalMasterpacks}
                      label={t("pallet_configuration.total_masterpacks")}
                    />
                  </MuiCol>
                </MuiRow>
              </MuiCol>
            </MuiRow>
          </Box>
          <MuiRow>
            <MuiCol size={12}>
              <ScannerInput
                disabled={currentPallet.palletBarcode === '' || !selectedExpeditionType}
                onChange={setScannerValue}
                onKeyDown={scannerOnKeyDown}
                value={scannerValue}
                label={t("newPallet.scanMasterpack")}
                error={scannerError}
              />
            </MuiCol>
          </MuiRow>
        </StandardPageTopContent>
        <StandardPageMainContent>
          <ReactTableBuilder columns={columns} data={tableData} maxRows={9}/>
        </StandardPageMainContent>
      </StandardPage>
      <div ref={el => (printContentRef = el)} display={!palletLabelInfo ?'none':'default'}>
        <PalletLabel palletInfo={palletLabelInfo} />
        {/* {barcode:17385998207795, totalmasterPacks:65} */}
      </div>
    </>
  );
}

NewPallet.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(NewPallet);